<template>
  <div id="Snow"></div>
</template>

<script setup>
import p5 from 'p5'
import {ref, reactive, watchEffect, onUnmounted, watch, onMounted} from 'vue'
import defaultValue from "@/utils/defaultValue"
import colorTool from "@/utils/colorTool"
import freeImg from "@/utils/freeImg"
const {freeImages} = freeImg()
const {defaultWidth, defaultHeight} = defaultValue()
const {changeToRgb} = colorTool()

const props = defineProps(['currentValue', 'effectTheme', 'controlMode'])

const effectThemeData = reactive(props.effectTheme)
let canvasWrap = ref('stop')
let nowTemperature = ref(null)
let animateSpeed = ref(10)
let backgroundColor = ref('rgb(0,0,0)')
let imgUrl = ref(null)
let imagePathType = ref('')
let backgroundImage = ref('')
let high = ref(null)
let low = ref(null)
let drawPot = ref(0)



const handleAnimateSpeedByTemperature = (high, low, now) => {
  let lowHeightRange = Math.ceil((high - low) / 5) // 將高低差 分為 10個單位, 1單位

  let range = Math.trunc((now - low) / lowHeightRange)
  // 調整速度
  if (range <= 0)  animateSpeed.value = 1 * 10
  else if (range >= 5) animateSpeed.value = 5 * 10
  else animateSpeed.value = range * 10
}

function initAnimate () {
  if (canvasWrap.value !== 'stop') {
    canvasWrap.value.remove()
    canvasWrap.value = 'stop'
  }
}


const snowAnimate = (sketch) => {
  let cw = defaultWidth.value
  let ch = defaultHeight.value
  let snowWrapWidth = (cw + 40) / 2
  let flakes = []
  let bg
  let vid

  sketch.setup = function () {
    sketch.createCanvas(cw, ch);
    sketch.noiseDetail(8, 0.25);
    bg = ''
    vid = ''
    flakes = []
    for (let i = 0; i < 210; i++) {
      let pos = sketch.createVector(sketch.random(cw), sketch.random(-ch, 0));
      let vel = sketch.createVector(sketch.random(-1, 1), 0)
      flakes.push(new Flake(i, pos, vel, sketch.random(4, 12))) // constructor(pos, vel, size)
    }
    if (
        imagePathType.value !== 'gif' &&
        imagePathType.value !== 'mp4' &&
        imagePathType.value !== 'webm' &&
        imgUrl.value &&
        imgUrl.value !== null &&
        imgUrl.value !== ''
    ) bg = sketch.loadImage(imgUrl.value)
    // 若 imgUrl.value .gif
    if (imagePathType.value === 'gif' &&
        imgUrl.value &&
        imgUrl.value !== null &&
        imgUrl.value !== ''
    ) {
      bg = sketch.createImg(imgUrl.value)
      bg.style('background-color', `${backgroundColor.value}`)
      bg.style('z-index', '-1')
      // 設置 背景圖 position
      bg.size(cw, ch)
      bg.position(0,0)
      // 將 canvas background 切換為 透明
      sketch.background(255, 255, 255, 0)
    }
    // 若 imgUrl.value .mp4 or .webm
    if (
        imagePathType.value === 'mp4' && imgUrl.value && imgUrl.value !== null && imgUrl.value !== '' ||
        imagePathType.value === 'webm' && imgUrl.value && imgUrl.value !== null && imgUrl.value !== ''
    ) {
      // mp4
      vid = sketch.createVideo(imgUrl.value)
      vid.style('background-color', `${backgroundColor.value}`)
      vid.style('z-index', '-1')
      vid.size(sketch.width, sketch.height);
      vid.position(0,0)
      vid.volume(0);
      vid.loop()
      sketch.background(backgroundColor.value)
    }
  }

  sketch.draw = function() {
    drawPot.value++
    sketch.clear()


    // 若 imgUrl.value 不是 .gif or .mp4
    if (
        imagePathType.value !== 'gif' &&
        imagePathType.value !== 'mp4' &&
        imagePathType.value !== 'webm'
    ) {
      // 添加 背景色
      sketch.background(backgroundColor.value)
      // 添加 背景圖
      if (imgUrl.value && imgUrl.value !== null && imgUrl.value !== '') sketch.image(bg, 0, 0, sketch.width, sketch.height)
    }

    for (let f of flakes) {
      f.move();
      f.show_low();
      if (animateSpeed.value > 20) f.show_default();
      if (animateSpeed.value > 30) f.show_double();
      f.wrap();
      if (drawPot.value > 7200 && f.index > 80) flakes.splice(f, 1)
    }

    if (flakes.length < 80 && drawPot.value > 7200) {
      for (let i = 0; i < 160; i++) {
        let pos = sketch.createVector(sketch.random(cw), sketch.random(-ch, 0));
        let vel = sketch.createVector(sketch.random(-1, 1), 0)
        flakes.push(new Flake(i, pos, vel, sketch.random(4, 12))) // constructor(pos, vel, size)
      }
      drawPot.value = 0
    }
  }

  class Flake {
    constructor(index ,pos, vel, size) {
      this.pos = pos;
      this.vel = vel;
      this.size = size;
      this.index = index
    }

    show_low() {
      sketch.push();
      sketch.translate(this.pos.x, this.pos.y);
      sketch.rotate(-this.pos.x / 300);
      sketch.fill(255, 255, 255, 160); // snow color
      sketch.noStroke();
      sketch.ellipse(0,50,this.size* 0.8, this.size* 0.8);

      sketch.pop();
    }
    show_default() {
      sketch.push();
      sketch.translate(this.pos.x, this.pos.y);
      sketch.rotate(-this.pos.x / 300);
      sketch.fill(255, 255, 255, 160); // snow color
      sketch.noStroke();
      sketch.ellipse(-50,0,this.size, this.size);


      sketch.fill(244, 244, 244, 130); // snow color
      sketch.noStroke();
      sketch.ellipse(0,150,this.size * 0.8, this.size * 0.8);

      sketch.pop();
    }
    show_double() {
      sketch.push();
      sketch.translate(this.pos.x, this.pos.y);
      sketch.rotate(-this.pos.x / 300);
      sketch.fill(255, 255, 255, 160); // snow color
      sketch.noStroke();
      sketch.ellipse(0,50,this.size, this.size);

      sketch.fill(236,232,232, 110); // snow color
      sketch.noStroke();
      // sketch.ellipse(0,-50,this.size, this.size);
      sketch.ellipse(75,0,this.size * 0.5 , this.size * 0.5)
      sketch.ellipse(0,75,this.size * 0.6 , this.size * 0.6);
      sketch.ellipse(0,-75,this.size * 0.5 , this.size * 0.5)

      sketch.ellipse(-175,0,sketch.random(3,6) * 0.5, sketch.random(3,6) * 0.5);
      sketch.ellipse(175,0,sketch.random(3,6) * 0.6, sketch.random(3,6) * 0.6);
      sketch.ellipse(0,-175,sketch.random(3,6) * 0.5, sketch.random(3,6) * 0.5);

      sketch.pop();
    }
    move() {
      this.pos.add(this.vel)
      this.vel.y +=  (this.size * sketch.random(sketch.abs(animateSpeed.value/3), sketch.abs(animateSpeed.value/5)) * 0.00002 * animateSpeed.value)
      this.vel.x -= this.size * this.size * ((sketch.width / 2) - snowWrapWidth ) / 1000000
    }
    wrap() {
      if (this.pos.y > sketch.height+50) {
        this.pos.x = sketch.random(sketch.width)
        this.pos.y = sketch.random(-sketch.height / 2, 0)
        this.vel.mult(0.5)
      }
      if (this.pos.x < 0) this.pos.x = sketch.width
      if (this.pos.x > sketch.width) this.pos.x = 0
      this.vel.x -= this.size * ((sketch.width / 2) - snowWrapWidth ) / 100000
    }
  }
}

watch(() => effectThemeData.Sensor, (Sensor) => {
  if (Sensor) {
    initAnimate()
    canvasWrap.value = new p5(snowAnimate, 'Snow')
  }
})

watchEffect(() => {
  const {
    HighValue,
    LowValue,
    IsDynamicMode,
    Speed: rotateSpeed,
    BackgroundColor,
    BackgroundImage
  } = effectThemeData

  // 背景色
  let bgColor = typeof BackgroundColor === "object" && BackgroundColor.length > 0 ? changeToRgb(BackgroundColor) : 'rgb(0,0,0)'

  // 背景色, 背景圖 需 重置動畫
  if (
      backgroundImage.value !== BackgroundImage ||
      backgroundColor.value !== bgColor
  ) {
    backgroundColor.value = bgColor
    imagePathType.value = ''
    backgroundImage.value = BackgroundImage
    if (backgroundImage.value !== '') {
      if (props.controlMode && props.controlMode.toString() === 'true') {
        const pathSplit = backgroundImage.value.split('.')
        imgUrl.value = freeImages[pathSplit[0]]
        imagePathType.value = pathSplit[1]
      } else {
        imgUrl.value = backgroundImage.value.split('#')[0]
        if (imgUrl.value.endsWith('.mp4')) imagePathType.value = 'mp4'
        else if (imgUrl.value.endsWith('.webm')) imagePathType.value = 'webm'
        else if (imgUrl.value.endsWith('.gif')) imagePathType.value = 'gif'
      }
    }
    if (backgroundImage.value === '') {
      imgUrl.value = ''
      imagePathType.value = ''
    }
    // create p5
    if (canvasWrap.value !== 'stop') {
      initAnimate()
      canvasWrap.value = new p5(snowAnimate, 'Snow')
    }
  }


  // animateSpeed 可以動態更新
  nowTemperature.value = props.currentValue && props.currentValue !== null ? props.currentValue : ''
  if (IsDynamicMode.toString() === 'false') {
    if (rotateSpeed && rotateSpeed > 0) animateSpeed.value = rotateSpeed
  }
  else if (IsDynamicMode.toString() === 'true') {
    high.value = HighValue
    low.value = LowValue
    // 控制雪量
    handleAnimateSpeedByTemperature(high.value, low.value, nowTemperature.value)
  }

})

onMounted(() => {
  if (canvasWrap.value === 'stop') canvasWrap.value = new p5(snowAnimate, 'Snow')
})

onUnmounted(() => {
  drawPot.value = 0
  nowTemperature.value = null
  animateSpeed.value = 10
  backgroundColor.value = 'rgb(0,0,0)'
  imgUrl.value = ''
  imagePathType.value = ''
  backgroundImage.value = ''
  high.value = null
  low.value = null
  initAnimate()
})

</script>
